export enum Event {
    CONNECT = 'connect',
    DISCONNECT = 'disconnect',
}

export enum Actions {
    SET_USER_ID = 'set_user_id',
    SET_EXECUTIONS = 'set_executions',
    SET_CURRENT_SITE = 'set_current_site',
}

export enum UISocketMessageType {
    TEXT = 'text',
    DATA = 'data',
}

export interface SetUserIdMessage {
    userId: string;
}

export interface UISocketTextMessage {
    type: UISocketMessageType.TEXT;
    message: unknown;
}

export interface UISocketDataMessage {
    type: UISocketMessageType.DATA;
}

export interface UISocketDeviceStateUpdateState {
    name: string;
    value: string;
}

export interface SetExecutionsMessage {
    executions: string[];
}
